import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GatemanService } from '../../../services/gateman.service';
import { PageService } from '../../../services/page.service';
import { AppService } from '../../../services/app.service';
import { Code2txtPipe } from '../../../pipes/code2txt.pipe';
import { MultiLangPipe } from '../../../pipes/multi-lang.pipe';
@Component({
  selector: 'app-list-item',
  templateUrl: './list-item.component.html',
  styleUrls: ['./list-item.component.scss']
})
export class ListItemComponent implements OnInit {
  @Input() config?;
  @Input() listConfig?; //config of parent list
  @Input() item; // list item object
  @Input() data?; // list data (diData)
  @Input() parentListLevel?: number = 0; //ListItem's parent level
  @Input() listIndex?: number = 0; //index of the list item in the above list
  @Input() listItemData?;
  level:number = 0;

  legend;

  listItem;

  constructor(
    private gatemanService: GatemanService,
    private activatedRoute: ActivatedRoute,
    private pageService: PageService,
    private appService: AppService,
    private code2txtPipe: Code2txtPipe,
    private multiLangPipe: MultiLangPipe
  ) {}

  ngOnInit() {

    // console.log('LIST ITEM CONFIG', this.config);
     //console.log('LIST ITEM ', this.item);
    this.level = this.parentListLevel;
    //COMMENTED BY NEIL 18/06/2019
    // if(this.listConfig.hasOwnProperty('legend')){
    //   this.legend = {...this.listConfig.legend }
    // }

    //NOTE: RESOLVE dynamic shortcode
    // console.log(`List Index ${this.listIndex} - List Level ${this.level}`);
    // console.log(this.item.config.content);

    let content = this.multiLangPipe.transform(this.item.config.content);

    this.listItem = {
      "label": this.multiLangPipe.transform(this.item.config.label),
      "content": this.code2txtPipe.transform(content, {"index": this.listIndex}),
      "controls": this.item.controls,
      "icon": this.item.config.icon,
      "url": this.item.config.url,
      "class": ""
    }



    //COMMENTED BY NEIL 18/06/2019
    // if(this.config){
    //   if(this.config.hasOwnProperty('legend') && this.config.legend){
    //     if(!Array.isArray(this.config.legend)){
    //       return;
    //     }
    //     this.legend = {...this.legend, ...this.appService.resolveItemLegend(this.config.legend, this.listItemData)}
    //   }
    // }


    if(this.config.hasOwnProperty('mapping')) {

      if(this.config.mapping.hasOwnProperty('labelKey') && this.config.mapping.labelKey) {
        let label = this.appService.findObjectByPath(this.item.listData, this.config.mapping.labelKey.split('.'));
        this.listItem.label = ``;
        if (label) {
          this.listItem.label = this.multiLangPipe.transform(label);
        }
      }

      if (this.config.mapping.hasOwnProperty('contentKey')) {
        if (this.config.mapping.contentKey) {
          let content = this.appService.findObjectByPath(this.item.listData, this.config.mapping.contentKey.split('.'));
          if (typeof content === 'boolean') {
            content = content.toString();
          }
          if (content) {
            this.listItem.content = content;
          }
        }
      }
    }

    if(this.config.hasOwnProperty('class')) {
      this.listItem.class = this.config.class;
    }
    console.log('LIST ITEM', this.listItem);



  }

  /**
   * [List item click handler via gateman service]
   * @param  link   [link object containing url]
   * @param  params [additional parameters to be passed e.g. target, listIndex]
   * @author Neil
   * @return[description]
   */
  go(link, params) {
     //console.log('link',link);
     //console.log(params);
    let config = {queryParams: params}

    if(link.hasOwnProperty('target')){
      config['target'] = link.target;
    }

    //console.log('config', config);

    this.gatemanService.routeHub(link.url, config);

  }

}
